    <div class="ring-container">
        <div class="ringring"></div>
        <div class="circle"></div>
    </div>
